import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import TextMessageAlerts from '../event-notification/TextMessageAlerts';

type FacilityTextMessageAlertsTabProps = {
  facility: Facility;
};

const FacilityTextMessageAlertsTab: React.FC<FacilityTextMessageAlertsTabProps> = ({
  facility,
}) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="row">
        <div className="col-md-12">
          <TextMessageAlerts facility={facility} />
        </div>
      </div>
    </div>
  );
};

export default FacilityTextMessageAlertsTab;
